function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.455 3.315c-1.268.563-2.63.942-4.06 1.112a7.08 7.08 0 0 0 3.108-3.91 14.16 14.16 0 0 1-4.49 1.715A7.057 7.057 0 0 0 23.855 0c-4.564 0-7.917 4.258-6.887 8.678C11.094 8.384 5.886 5.57 2.4 1.293c-1.852 3.177-.96 7.334 2.186 9.438a7.039 7.039 0 0 1-3.2-.884c-.077 3.274 2.27 6.338 5.67 7.02a7.085 7.085 0 0 1-3.193.12 7.074 7.074 0 0 0 6.604 4.909A14.212 14.212 0 0 1 0 24.824 20.01 20.01 0 0 0 10.836 28c13.124 0 20.54-11.084 20.091-21.026a14.392 14.392 0 0 0 3.528-3.66z",
  fill: "url(#twitter_alt_svg__paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "twitter_alt_svg__paint0_linear",
  x1: 0,
  y1: 0,
  x2: 27.408,
  y2: 33.726,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#77BDFF"
})));

var SvgTwitterAlt = function SvgTwitterAlt(props) {
  return React.createElement("svg", _extends({
    width: 35,
    height: 28,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAzNSAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOmhhcmQtbGlnaHQiPgo8cGF0aCBkPSJNMzQuNDU0NSAzLjMxNDgxQzMzLjE4NjggMy44Nzc1NiAzMS44MjQ0IDQuMjU2NTYgMzAuMzk0NiA0LjQyNzRDMzEuODU0NiAzLjU1MzEyIDMyLjk3NTggMi4xNjc3NiAzMy41MDI3IDAuNTE2ODE3QzMyLjEzNzQgMS4zMjY1IDMwLjYyNDMgMS45MTUwOSAyOS4wMTM1IDIuMjMyMzZDMjcuNzI1OCAwLjg1ODQ5MSAyNS44ODY4IC0xLjM0MTcyZS0wNyAyMy44NTQgLTEuMzQxNzJlLTA3QzE5LjI5MDIgLTEuMzQxNzJlLTA3IDE1LjkzNjYgNC4yNTggMTYuOTY3NCA4LjY3ODIyQzExLjA5NDMgOC4zODM5MiA1Ljg4NTk3IDUuNTcwMTQgMi4zOTg4OSAxLjI5MzQ4QzAuNTQ2OTY1IDQuNDcwNDcgMS40Mzg0NyA4LjYyNjU0IDQuNTg1MzIgMTAuNzMxMUMzLjQyODIyIDEwLjY5MzggMi4zMzcxNiAxMC4zNzY1IDEuMzg1MzYgOS44NDY4QzEuMzA3ODMgMTMuMTIxNCAzLjY1NTA1IDE2LjE4NSA3LjA1NDU1IDE2Ljg2NjlDNi4wNTk2OCAxNy4xMzY4IDQuOTcwMDYgMTcuMiAzLjg2MTc3IDE2Ljk4NzVDNC43NjA0NiAxOS43OTU1IDcuMzcwMzkgMjEuODM4NCAxMC40NjU1IDIxLjg5NThDNy40OTM4NSAyNC4yMjU4IDMuNzQ5NzkgMjUuMjY2NiAwIDI0LjgyNDRDMy4xMjgxOCAyNi44MyA2Ljg0NDk1IDI4IDEwLjgzNTkgMjhDMjMuOTYwMiAyOCAzMS4zNzUxIDE2LjkxNTcgMzAuOTI3MiA2Ljk3NDE2QzMyLjMwODIgNS45NzY0MiAzMy41MDcgNC43MzE3NSAzNC40NTQ1IDMuMzE0ODFaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjAiIHkxPSIwIiB4Mj0iMjcuNDA4MSIgeTI9IjMzLjcyNjIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0id2hpdGUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNzdCREZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgTwitterAlt as ReactComponent };